import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type External_DevicesMutationVariables = Types.Exact<{
  property_id: Types.Scalars['uuid']['input'];
  partner_association: Types.Scalars['String']['input'];
  account_id: Types.Scalars['uuid']['input'];
}>;


export type External_DevicesMutation = { __typename?: 'mutation_root', external_devices?: Array<{ __typename?: 'ExternalDevicesOutput', id: string, device_name: string, event_state: string } | null> | null };


export const External_DevicesDocument = gql`
    mutation external_devices($property_id: uuid!, $partner_association: String!, $account_id: uuid!) {
  external_devices(
    property_id: $property_id
    partner_association: $partner_association
    account_id: $account_id
  ) {
    id
    device_name
    event_state
  }
}
    `;
export type External_DevicesMutationFn = Apollo.MutationFunction<External_DevicesMutation, External_DevicesMutationVariables>;

/**
 * __useExternal_DevicesMutation__
 *
 * To run a mutation, you first call `useExternal_DevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternal_DevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalDevicesMutation, { data, loading, error }] = useExternal_DevicesMutation({
 *   variables: {
 *      property_id: // value for 'property_id'
 *      partner_association: // value for 'partner_association'
 *      account_id: // value for 'account_id'
 *   },
 * });
 */
export function useExternal_DevicesMutation(baseOptions?: Apollo.MutationHookOptions<External_DevicesMutation, External_DevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<External_DevicesMutation, External_DevicesMutationVariables>(External_DevicesDocument, options);
      }
export type External_DevicesMutationHookResult = ReturnType<typeof useExternal_DevicesMutation>;
export type External_DevicesMutationResult = Apollo.MutationResult<External_DevicesMutation>;
export type External_DevicesMutationOptions = Apollo.BaseMutationOptions<External_DevicesMutation, External_DevicesMutationVariables>;